<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type="primary" v-if="type === 1 || type === 2 ||  type === 4" @click="save" :loading="btnLoading">保存</el-button>
      <vxe-button type="primary" v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <!-- <el-button v-if="type === 1 || type === 2 || type === 3" @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <div>
      <el-form :model="user" ref="ruleForm" label-position="right" class="mainfrom">
        <div>
        <div >
          <!--<el-form-item label="登录账号" prop="usercode" :verify="validateUsercode">-->
          <!--<el-input v-model="user.usercode" :maxlength="20" :disabled="disable"></el-input>-->
          <!--</el-form-item>-->
          <!--<div v-if="type===1">-->
          <!--<el-form-item label="密码" prop="userpassword" verify>-->
          <!--<el-input v-model="user.userpassword" type="password"  :maxlength="124" :disabled="disable"></el-input>-->
          <!--</el-form-item>-->
          <!--</div>-->
        <div class="from_input">
          <el-form-item label="手机" prop="usermobile" verify>
            <div class="row">
              <el-input v-model="user.usermobile"  :maxlength="11" :disabled="type === 1 ? false:true"></el-input>
              <el-button v-if="user.userid === $store.getters.loginUser.userid" type='primary' size="mini" @click="changeTelephone">修改号码</el-button>
              <div class="alertmsg"><span>该手机号码作为登录账号，登录密码默认为手机号码后六位</span></div>
            </div>
          </el-form-item>
          <div>
          <el-form-item label="姓名" prop="username" verify>
            <el-input v-model="user.username" :maxlength="40" :disabled="disable"></el-input>
          </el-form-item>
            <el-form-item label="电话" prop="usertel" verify>
              <el-input v-model="user.usertel" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" verify prop="useremail">
              <el-input v-model="user.useremail" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
             <!-- <el-form-item label="用户编号" verify prop="usernumber">
              <el-input v-model="user.usernumber" :maxlength="2" :disabled="disable"></el-input>
            </el-form-item> -->
          </div>
          <div >
             <!-- verify prop="userdptid" -->
            <el-form-item label="部门" >
              <!--&& $store.getters.loginUser.adminflag-->
              <el-select v-model="user.userdptid" placeholder="请选择" :disabled="(type !== 3) ? false : true">
                <el-option v-for="item in dptList" :key="item.dptid" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item label="默认单位类型" v-if="userComTypeList.length > 1">-->
              <!--<el-select v-model="defaultComType" :disabled="disable">-->
                <!--<el-option v-for="(item, index) in userComTypeList" :label="item.comtypename" :value="+item.comtypecode" :key="index"></el-option>-->
              <!--</el-select>-->
            <!--</el-form-item>-->
          </div>
        </div>
        <div >
          <el-form-item required label="权限">
            <div>
            <el-select v-model="roleids" :disabled="(type !== 3) ? false : true">
              <!-- <el-option v-for="(item,index) in roleList" :label="item.rolename" :value="item.roleid" :key="index"></el-option> -->
              <el-option v-for="(item,index) in roleList"  :key="index" :label="item.rolename" :value="item.roleid">
              </el-option>
            </el-select>
            </div>
          </el-form-item>
        </div>
        </div>
        </div>
        <!--<div class="content">-->
        <!--<el-form-item label="备注">-->
        <!--<el-input v-model="user.userremark" type="textarea" :maxlength="255" show-word-limit :disabled="disable"></el-input>-->
        <!--</el-form-item>-->
        <!--</div>-->
      </el-form>
      </div>

        <!-- <el-button v-if="type === 1 || type === 2 ||  type === 4" @click="addAppend" :loading="btnLoading">新增</el-button>
      <el-button v-if="type === 1 || type === 2 ||  type === 4" @click="chgAppend" :loading="btnLoading">修改</el-button>
      <el-button v-if="type === 1 || type === 2 ||  type === 4" @click="delAppend" :loading="btnLoading">删除</el-button> -->
      <!-- 弹窗 -->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
        <div class="addexport">
          <el-form :model="appendItem" ref="ruleAppend" label-position="right" class="mainfrom from_input">
            <el-form-item label="附件类型" prop="appendtype" verify>
              <el-select v-model="appendItem.appendtype" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in appendTypeList" :label="item.label" :value="item.value"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传附件" prop="appendurl" verify>
              <upload-pic-one @changed="setPic" :picUrl="appendItem.appendurl" folderName="com"
                              text="选择文件"></upload-pic-one>
            </el-form-item>
            <div class="row">
              <el-form-item label="附件编号">
                <el-input v-model="appendItem.appendfilecode" :maxlength="128" show-word-limit
                          :disabled="disable"></el-input>
              </el-form-item>

              <el-form-item label="附件名称" prop="appendfilename" verify>
                <el-input v-model="appendItem.appendfilename" :maxlength="128" show-word-limit
                          :disabled="disable"></el-input>
              </el-form-item>
            </div>

          </el-form>
          <div style="overflow:hidden">
            <el-button type="primary" @click="saveAppend" style="float:right;margin-right:20px;">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
              @cellClick="cellClick"
          :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
      >
          <template slot="btn">
            <div class="btn-box">
              <vxe-button type="text" icon="vxe-icon--plus" v-if="type === 1 || type === 2 ||  type === 4" @click="addAppend" :loading="btnLoading">新增</vxe-button>
            </div>
          </template>
      </vggrid>
    </div>
    <el-dialog
      title="修改手机号"
      :visible.sync="PhoneFlg"
      width="40%"
      :before-close="handlePhoneClose">
        <el-form :model="model" ref="ruleForm" label-position="right" class="mainfrom">
          <el-form-item label="手机号" prop="telephone" :verify="validateUsercode">
              <div class="value">
                <el-input placeholder="请输入手机号码" v-model="model.telephone" clearable></el-input>
              </div>
          </el-form-item>
          <el-form-item label="验证码" prop="yzm" verify>
            <div class="p-row">
              <div class="value">
                <el-input placeholder="请输入短信验证码" v-model="model.yzm" clearable></el-input>
              </div>
              <div class="yzmbtn" @click="getsms">
                <sec-count-down v-if="sendFlag" @stop="stop">秒后获取</sec-count-down>
                <span v-else>发送验证码</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label=" ">
              <el-button type='primary' @click="submit">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import Md5 from '../../assets/js/md5'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import _ from 'lodash'
  import Regular from '@/assets/js/regular'
  import uploadPicOne from '../common/uploadPicOne'
  import SecCountDown from '../common/secCountDown'
  import config from '../../assets/config'

  const SUCCESS = 1
  export default {
    name: "userform",
    mixins: [common],
    data () {
      return {
        user: {},
        isOperate:true,
        userdptid: '',
        roleids: '',
        defaultComType: '',
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'appendtypeCN', fieldtype: 'C', title: '附件类型', calculExpr: ''},
          {field: 'appendfilecode', fieldtype: 'C', title: '文件编号', calculExpr: ''},
          {field: 'appendfilename', fieldtype: 'C', title: '文件名', calculExpr: ''}
          // { field: 'appendurl', fieldtype: 'C',title: 'URL',calculExpr:''}
        ],
        append: {},
        list: [],
        userComTypeList: [],
        roleList: [],
        btnLoading: false,
        dptList: [],
        appendTypeList: [],
        appendItem: {},
        dialogVisible: false,
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        PhoneFlg:false,
        sendFlag:false,
        model: {
          telephone:'',
          isDisabledBtn: false,
          yzm: ''
        }
      }
    },
    async activated () {
      this.type = Number(this.$route.params.type),
      this.disable = this.$route.params.type === 3 ? true : false
      this.user = this.$route.params.form
      if(this.$route.params.form.userid){
        await this.getUser()
      }
      this.model= {
          telephone:'',
          isDisabledBtn: false,
          yzm: ''
        }
      this.append = {}
      this.list = []
      this.appendItem = {}
      this.appendTypeList = []
      await this.getDptList()
      await this.getList()
      await this.getAppendType()
      await this.getUserRolePageList()
      if(this.user.userid) {
        await this.getUserRoleList()
      } else {
        this.roleids = ''
      }
    },
    created(){
      this.$on('CHG', () => this.chgAppend())
      this.$on('DEL', () => this.delAppend())
    },
    watch: {},
    filters: {},
    components: {vggrid, uploadPicOne,SecCountDown},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      validate(rule, val, callback) {
        console.log(val,23232323)
        if (!val.length) {
          callback(Error('请对该用户授权'))
        } else {
          callback()
        }
      },
      vggridClick(code,row){
        this.append = row
        this.$emit(code,row)
      },
      async getUser () {
        console.log( this.$route.params, 90909)
        let model = {}
        model.userid = this.$route.params.form.userid
        model.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getUserInfo',
          params: model
        })
        if (res.length) {
          this.user = res[0]
        }
      },
      async getUserRoleList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/userrole/getUserRoleList',
          params: {userid: this.user.userid,currentcomtype:this.user.comtype,cosid:this.$store.getters.loginUser.cosid}
        })
        this.roleids = res[0].roleid
        // this.roleids = res
        this.loading = false
      },
      async getUserRolePageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/userrole/getPageList',
          params: {cosid:this.$store.getters.loginUser.cosid,comid: this.user.usercomid,currentcomtype:this.user.comtype,userid: this.user.userid ? this.user.userid : 0}
        })
        this.roleList = res.filter(v => +v.roletype !== 4)
        this.loading = false
      },
      validateUsercode (rul, val, callback) {
        this.user.usercode = _.trim(val)
        this.validateData('号码已存在', 'userrec', 'userid', 'usercode', val, callback)
      },
      validateData (msg, tablename, fieldid, checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename, fieldid, checkfield, checkval: this.user[checkfield]}
        }).then(res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      async getAppendType () {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'appendtype'}
        })
      },
      async getDptList () {
        this.dptList = await request({
          method: 'get',
          url: '/xtgl/dpt/getDptList',
          params: {comid: this.user.usercomid}
        })
      },
      async cellClick (row) {
        this.append = row.row
      },
      async getList () {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'appendtype'}
        })
        if (this.appendTypeList) {
          this.list = await request({
            url: '/ywgl/append/getPageList',
            method: "get",
            params: {appendfromid: this.user.userid, appendfromtype: 2}
          })
          for (let i = 0; i < this.list.length; i++) {
            for (let j = 0; j < this.appendTypeList.length; j++) {
              if (this.list[i].appendtype == this.appendTypeList[j].syscodeseq) {
                this.list[i].appendtypeCN = this.appendTypeList[j].label
              }
            }
          }
        }
      },
      async addAppend () {
        let i = 1
        this.list.forEach(item => {
          if (item.appendseq >= i) {
            i = item.appendseq + 1
          }
        })
        this.appendItem.appendfromid = this.user.userid,
          this.appendItem.appendfromtype = '2',
          this.appendItem.appendseq = i,
          this.appendItem.returnForm = 'userForm'
        this.dialogVisible = true
      },
      async chgAppend () {
        if (!this.append.id) {
          this.$message.warning('请选择一行!')
          return
        }
        this.appendItem = _.cloneDeep(this.append)
        this.dialogVisible = true
      },
      async delAppend () {
        if (!this.append.id) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          this.appendItem = _.cloneDeep(this.append)
          this.list.forEach((key, index) => {
            this.list.forEach((key, index) => {
              if (key.id === this.appendItem.id) {
                this.list.splice(index, 1)
              }
            })
          })
          this.appendItem = {}
        })
      },
      async save () {
        this.submitForm('ruleForm').then(async() => {
          if (!this.roleids) {
            this.$message.warning('请对该用户授权！')
            return
          }
          this.user.roleid = this.roleids
          this.user.usercode = this.user.usermobile
          this.user.userpassword = Md5.md5(this.user.usermobile.slice(this.user.usermobile.length - 6))
          this.user.appendfromtype = 1
          // this.user.userdptid = this.userdptid
          // if (+this.$store.getters.loginUser.userid === +this.user.userid) {
          //   this.user.userdefaultcomtype = this.defaultComType
          // }
          // if (!this.user.userid) {
          //   this.user.userdefaultcomtype = this.$store.getters.loginUser.comtype
          // }
          this.user.currentcomtype = this.user.comtype
          this.user.coisd = this.$store.getters.loginUser.cosid
          this.user.list = this.list
          let data = await request({
            url: '/xtgl/user/selectUserdata',
            method: "post",
            data: this.user
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          }

          else if(data.issuccess === -2){
            this.$message.warning('该用户在此平台已存在其他单位，请核实')
          }
          else {
            this.user.userpassword = ''
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'userIndex'})
      },
      async handleClose (done) {
        this.appendItem = {}
        this.dialogVisible = false
      },
      async setPic (path, filename, filecode) {
        this.$set(this.appendItem, 'appendfilecode', filecode)
        this.$set(this.appendItem, 'appendfilename', filename)
        this.$set(this.appendItem, 'appendurl', path.replace(this.uploadAddr, ''))
      },
      async saveAppend () {
        this.appendTypeList.forEach(key => {
          if (key.syscodeseq == this.appendItem.appendtype) {
            this.appendItem.appendtypeCN = key.label
          }
        })
        this.submitForm('ruleAppend').then(async() => {
          if (this.appendItem.id) {
            this.list.forEach((key, index) => {
              if (key.id === this.appendItem.id) {
                this.list.splice(index, 1, this.appendItem)
              }
            })
          }
          else {
            this.list.push(this.appendItem)
          }
          this.dialogVisible = false
          this.append = this.appendItem
          this.appendItem = {}
        }).catch(() => {
        })
      },
      changeTelephone(){
        this.PhoneFlg = true
      },
      handlePhoneClose() {
        this.PhoneFlg = false
      },
      async submit(){
        this.submitForm('ruleForm').then(async() => {
          this.$confirm('修改成功后将退出登录，是否确定', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async() => {
            this.validate2()
            if(!this.model.yzm){
              this.$message.warning('请填写验证码！')
              return
            }
            if (this.errMsg !== '') {
              this.$message({
                message: this.errMsg,
                type: "warning"
              })
              return
            }
            this.model.userid = this.user.userid

            let data = await request({
              url: '/web/web/changephone',
              method: "post",
              data: this.model
            })
            if (data.issuccess === 3) {
              this.$message.warning('该账号已存在！')
            } else {
              if (data.issuccess === 1) {
                this.$message.success('更该成功')
                setTimeout(() => {
                  this.exist()
                }, 1500)
                
              this.model = {
                telephone:'',
                isDisabledBtn: false,
                yzm: ''
              }
                this.PhoneFlg = false
              } else {
                this.$message.error('验证码错误')
                this.isDisabledBtn = false
              }
            }
          })
        })
      },
      async exist () {
        await request({
          method: 'post',
          url: '/token/setCache',
          data: {key: this.$store.state.user.loginUser.cacheToken}
        }).then(() => {
          let cacheToken = this.$store.state.user.loginUser.cacheToken
          this.$store.commit('login_out')
          location.href = `${config.webUrl}/#/login?t=${cacheToken}`
        })
      },
      async getsms() {
        this.validate2()
        if (this.errMsg !== '') {
          this.$message({
            message: this.errMsg,
            type: "warning"
          })
          return
        }
        if (this.isDisabledBtn) {
          return
        }
        let res = await request({
          url: '/sms/send',
          method: 'get',
          params: {type: '1', tel: this.model.telephone}
        })
        this.sendFlag = true
        this.isDisabledBtn = true
        this.model.yzmToken = res.data
        if (res.issuccess) {
          this.$message.success('验证码获取成功')
          this.isDisabledBtn = true
          this.sendFlag = true
        } else {
          this.isDisabledBtn = false
          this.sendFlag = false
          this.$message({
            message: '获取验证码失败，请30秒后再重新获取',
            type: "warning"
          })
        }
      },
      stop () {
        this.sendFlag = false
        this.isDisabledBtn = false
      },
      validate2 () {
        var reg = Regular.GetRegularExpression('telphone')
        if (!this.model.telephone) {
          this.errMsg = '请输入手机号码!'
        } else if (!reg.test(this.model.telephone)) {
          this.errMsg = '手机号码格式不正确！'
        } else {
          this.errMsg = ''
        }
      }
    }
  }
</script>


<style lang="scss" scoped>

  .btn-box{
    overflow: hidden;
      .vxe-button{
        padding: 10px 10px;
        font-size: 16px;
      }
  }
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .from_select .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 520px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
    .alertmsg {
      color:red;
      width: 200px;
      line-height: 18px;
      word-break: break-all;
      word-wrap: break-word;
      overflow-y: hidden;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .p-row{
    display: flex;
    // margin: 10px 0;
    align-items: center;
    .lab{
      width: 80px;
    }
    .value{
      // margin-left: 20px;
    }
    .yzmbtn {
      cursor: pointer;
      border: 1px solid #F46722;
      padding:0 7px;
      margin-left: 10px;
      color: #F46722;
    }
  }
</style>
